import type { Roles } from "../../../../interface/interfaces";

interface RoleActionsProps {
  role: Roles;
  onViewDetails: (role: Roles) => void;
  onUpdate: (role: Roles) => void;
}

const RoleActions = ({ role, onViewDetails, onUpdate }: RoleActionsProps) => {
  const handleUpdate = () => {
    console.log("Update role:", role);
    onUpdate(role);
  };

  return (
    <div className="flex gap-2">
      <button
        onClick={() => onViewDetails(role)}
        className="px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md text-sm font-medium transition-colors shadow-sm"
      >
        View Details
      </button>
      {(role.isAdminRole || role.isSystemRole) && (
        <button
          onClick={handleUpdate}
          className="px-4 py-2 bg-gray-600 text-white hover:bg-gray-700 rounded-md text-sm font-medium transition-colors shadow-sm"
        >
          Update
        </button>
      )}
    </div>
  );
};

export default RoleActions;
